export default {
    operationSuccess: 'УСПЕШНАЯ ОПЕРАЦИЯ!',
    operationError: 'ОШИБКА ОПЕРАЦИИ!',
    synchronizationSuccess: 'СИНХРОНИЗАЦИЯ ЗАВЕРШЕНА!',
    synchronizationError: 'ОШИБКА СИНХРОНИЗАЦИИ!',
    connectionSuccess: 'ИНТЕГРАЦИЯ ПОДКЛЮЧЕНА!',
    connectionError: 'ОШИБКА ПОДКЛЮЧЕНИЯ!',
}